import React from "react"
import { css } from "styled-components"

const Map = ({ url }) => {
  return (
    <div
      css={css`
        width: 100%;
        padding-bottom: 100%;
        position: relative;
      `}
    >
      <iframe
        title="map-fragment"
        src={url}
        loading="lazy"
        css={css`
          position: absolute;
          width: 100%;
          height: 100%;
          border: 0;
          padding-left: 0;
          padding-right: 0;
          padding-bottom: 0;
        `}
        frameborder="0"
      />
    </div>
  )
}

export default Map
